export const VEHICLE_ROUTE = '/fleet';
export const DRIVER_ROUTE = '/driver';
export const ADMINISTRATION_ROUTE = '/administration';
export const CODRIVER_ROUTE = '/co-driver';
export const WELCOME_ROUTE = '/welcome';
export const REPORT_ROUTE = '/reports';
export const CREATE_REPORT_ROUTE = '/reports/new';
export const EDIT_REPORT_ROUTE = '/reports/edit';
export const VIEW_REPORT_ROUTE = '/reports/view';
